var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"loader"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","fill":"none","r":"20","stroke-miterlimit":"10","stroke-width":"3"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }